module.exports = __webpack_public_path__ + "static/media/online.de72ec12.svg";